/* eslint-disable import/prefer-default-export */
export const initialStateClients = {
  // List of clients
  data: [],
  // The currently selected client
  selectedClient: {},
  isEditing: false,
  isLoading: false,
  // The currently selected client
  cid: false,
  // The currently selected subscription
  sub: false,
  // The general app meta for each subscription
  apps: {},
  // The client actions currently being loaded asynchronously
  loading: [],
  // The list of users associated with the logged in user's client
  users: [],
  // The list of clients associated with the logged in user
  clients: [],
  // The list of approles associated with the logged in user
  approles: [],
  // What db related changes have been made on the clients behalf
  auditLogs: [],
};
